import React from 'react';
import { ArrowDown, Loader2, Check } from 'lucide-react';
import { usePullToRefresh } from '../../hooks/usePullToRefresh';
import './PullToRefreshIndicator.scss';

export interface PullToRefreshIndicatorProps {
  onRefresh?: () => Promise<void> | void;
  disabled?: boolean;
}

export const PullToRefreshIndicator: React.FC<PullToRefreshIndicatorProps> = ({
  onRefresh,
  disabled = true,
}) => {
  const { state, indicatorRef, arrowRef } = usePullToRefresh({
    onRefresh,
    disabled,
  });

  if (disabled) {
    return null;
  }

  const getLabel = () => {
    switch (state) {
      case 'ready':
        return 'Release to refresh';
      case 'refreshing':
        return 'Refreshing...';
      case 'completed':
        return 'Updated';
      case 'pulling':
      default:
        return 'Pull to refresh';
    }
  };

  const isActive = state !== 'idle';

  return (
    <div
      ref={indicatorRef}
      className={`ptr-container ${isActive ? 'is-active' : ''}`}
      aria-live="polite"
      role="status"
    >
      <div className="ptr-pill">
        <div className="ptr-icon-wrap">
          {state === 'completed' ? (
            <Check size={16} className="ptr-check" strokeWidth={3} />
          ) : state === 'refreshing' ? (
            <Loader2 size={16} className="ptr-spinner" strokeWidth={2.5} />
          ) : (
            <ArrowDown
              ref={arrowRef}
              size={15}
              className="ptr-arrow"
              strokeWidth={2.5}
            />
          )}
        </div>
        <span className="ptr-label">{getLabel()}</span>
      </div>
    </div>
  );
};
